const ISO_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})/;
const DDMMYYYY_REGEX = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

const MONTH_NAMES = [
	"Janeiro",
	"Fevereiro",
	"Março",
	"Abril",
	"Maio",
	"Junho",
	"Julho",
	"Agosto",
	"Setembro",
	"Outubro",
	"Novembro",
	"Dezembro",
];

export function formatCurrency(value: number): string {
	return new Intl.NumberFormat("pt-BR", {
		style: "currency",
		currency: "BRL",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(value);
}

export function formatCurrencyOrDash(value: number): string {
	if (value > 0) {
		return formatCurrency(value);
	}

	return "—";
}

/** Formata data para exibição na tabela (dd/MM/yy). Aceita ISO (yyyy-MM-dd) ou dd/MM/yyyy. */
export function formatDateShort(value: string): string {
	if (!value) {
		return "—";
	}
	const isoMatch = ISO_DATE_REGEX.exec(value);
	if (isoMatch) {
		return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1].slice(-2)}`;
	}
	const ddmmyyyyMatch = DDMMYYYY_REGEX.exec(value);
	if (ddmmyyyyMatch) {
		return `${ddmmyyyyMatch[1].padStart(2, "0")}/${ddmmyyyyMatch[2].padStart(2, "0")}/${ddmmyyyyMatch[3].slice(-2)}`;
	}
	return value;
}

export function formatPercent(value: number): string {
	const sign = value > 0 ? "+" : "";
	return `${sign}${Math.round(value)}%`;
}

export function formatPeriodMonthYear(month: number, year: number): string {
	if (month < 1 || month > 12) {
		return "";
	}
	return `${MONTH_NAMES[month - 1]} ${year}`;
}

export function getMonthName(month: number): string {
	if (month < 1 || month > 12) {
		return "";
	}
	return MONTH_NAMES[month - 1];
}
